<app-header title="self-serve.payYourTeam.addYourCanadianBankAccount"></app-header>
<p class="text-color-secondary-font margin-bottom-6">{{ 'self-serve.payYourTeam.bankAccountDetails' | translate }}</p>
<form
    #form="ngForm"
    [appFormPersistence]="!stepStatus && !isLoading ? 'bankForm' : ''"
    [class.loading]="isLoading"
    (ngSubmit)="onSubmit()"
>
    <div class="responsive-grid">
        <div class="row">
            <mat-form-field>
                <mat-label>{{ 'self-serve.payYourTeam.institutionNumber' | translate }}</mat-label>
                <input
                    required
                    pattern="\d{3}"
                    matInput
                    type="text"
                    name="institutionNumber"
                    #institutionNumber="ngModel"
                    [(ngModel)]="bankAccount.institutionNumber"
                />

                <mat-hint>{{ 'self-serve.payYourTeam.institutionNumberHint' | translate }}</mat-hint>
                <mat-error *ngIf="institutionNumber.invalid">{{
                    'self-serve.payYourTeam.institutionNumberInvalid' | translate
                }}</mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{ 'self-serve.payYourTeam.branchNumber' | translate }}</mat-label>
                <input
                    required
                    pattern="\d{5}"
                    matInput
                    type="text"
                    name="branchNumber"
                    #branchNumber="ngModel"
                    [(ngModel)]="bankAccount.branchNumber"
                />

                <mat-hint>{{ 'self-serve.payYourTeam.branchNumberHint' | translate }}</mat-hint>
                <mat-error *ngIf="branchNumber.invalid">{{
                    'self-serve.payYourTeam.branchNumberInvalid' | translate
                }}</mat-error>
            </mat-form-field>
        </div>

        <div class="row w-100 lg-w-50">
            <mat-form-field>
                <mat-label>{{ 'self-serve.payYourTeam.accountNumber' | translate }}</mat-label>
                <input
                    required
                    pattern="\d{5,12}"
                    matInput
                    type="text"
                    name="accountNumber"
                    #accountNumber="ngModel"
                    [(ngModel)]="bankAccount.accountNumber"
                />

                <mat-hint>{{ 'self-serve.payYourTeam.accountNumberHint' | translate }}</mat-hint>
                <mat-error *ngIf="accountNumber.invalid">{{
                    'self-serve.payYourTeam.accountNumberInvalid' | translate
                }}</mat-error>
            </mat-form-field>
        </div>
    </div>

    <div class="flex buttons justify-end">
        <ui-button *ngIf="showIWillDoItLater" type="outline" (click)="next()">{{
            'self-serve.iWillDoItLater' | translate
        }}</ui-button>
        <ui-button type="primary" [submit]="true" [disabled]="isSaving">{{ 'save' | translate }}</ui-button>
    </div>
</form>
